










import Vue from 'vue'
import FileUpload from '@/UI/Shared/FileUpload/FileUpload.vue'
import { FileInfoDTO } from '@/Application/ReviewedDocumentation'
import { FileUploadOptions } from '@/UI/Shared/FileUpload/FileUploadOptions'

export default Vue.extend({
  name: 'UploadReviewFile',
  components: {
    FileUpload
  },
  data () {
    return {
      file: ''
    }
  },
  props: {
    reviewItem: {
      type: FileInfoDTO,
      required: true
    },
    procedureId: {
      type: Number,
      required: true
    },
    batchId: {
      type: Number,
      required: true
    },
    madeiristaId: {
      type: Number,
      required: true
    }
  },
  computed: {
    uploadUrl (): string {
      if (process.env.VUE_APP_API_ENV === 'local') {
        return 'https://httpbin.org/post'
      }
      let baseUrl = process.env.VUE_APP_API_URL + '/sobree/api/documentation/rectified/'
      baseUrl = baseUrl + `${this.procedureId}/${this.madeiristaId}/${this.batchId}/`
      baseUrl = baseUrl + `${this.numericIdByType}/${this.reviewItem.documentId}`
      return baseUrl
    },
    numericIdByType (): string {
      const equivalences: {[key: string]: string} = {
        STP: '1',
        SEF: '2',
        IAE: '3',
        DGP: '4',
        ECN: '5',
        POB: '6',
        ACR: '7'
      }
      return equivalences[this.reviewItem.fileType] || '9'
    },
    options (): FileUploadOptions {
      return {
        url: this.uploadUrl,
        acceptedFiles: 'application/pdf,.zip',
        maxFilesize: 30,
        maxFiles: 1,
        chunkSize: 500,
        createImageThumbnails: false,
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        addRemoveLinks: true,
        dictDefaultMessage: this.$t('shared.fileUpload.dictDefaultMessage').toString(),
        dictFallbackMessage: this.$t('shared.fileUpload.dictFallbackMessage').toString(),
        dictFallbackText: this.$t('shared.fileUpload.dictFallbackText').toString(),
        dictFileTooBig: this.$t('shared.fileUpload.dictFileTooBig').toString(),
        dictBadExtension: this.$t('shared.fileUpload.dictBadExtension').toString(),
        dictResponseError: this.$t('shared.fileUpload.dictResponseError').toString(),
        dictCancelUpload: this.$t('shared.fileUpload.dictCancelUpload').toString(),
        dictUploadCanceled: this.$t('shared.fileUpload.dictUploadCanceled').toString(),
        dictCancelUploadConfirmation: this.$t('shared.fileUpload.dictCancelUploadConfirmation').toString(),
        dictRemoveFile: this.$t('shared.fileUpload.dictRemoveFile').toString(),
        dictMaxFilesExceeded: this.$t('shared.fileUpload.dictMaxFilesExceeded').toString()
      }
    }
  },
  methods: {
    onFileAddComplete (name: string) {
      if (name !== '') {
        this.file = name
        this.$emit('file-uploaded')
      }
    }
  }
})
